import {
    MODERATION_REJECT_MESSAGE,
    getModerationSyncError,
} from "../../server/moderationSync";

export { MODERATION_REJECT_MESSAGE };

export async function validateUserContentAppropriate(text: string): Promise<string | null> {
    return getModerationSyncError(text);
}
